import * as tslib_1 from "tslib";
import { DataApi } from '../api/DataApi';
import { TRACK_EVENT_COLLECTION } from '../constants';
import { APP_DEFINITION_ID, STORAGE_PAGINATION_KEY } from '@wix/wixstores-client-core/dist/es/src/constants';
import { ProductActions } from '@wix/wixstores-client-core/dist/es/src/product-actions/ProductActions';
var ProductsService = /** @class */ (function () {
    function ProductsService(siteStore, productsPerPage, consumerName) {
        this.siteStore = siteStore;
        this.productsPerPage = productsPerPage;
        this.consumerName = consumerName;
        this.dataApi = new DataApi(this.siteStore);
        this.productActions = new ProductActions(this.siteStore);
    }
    ProductsService.prototype.getProducts = function (filters, collectionIds, sorting) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var apiResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dataApi.getProducts(0, this.productsPerPage, filters, collectionIds, sorting)];
                    case 1:
                        apiResponse = _a.sent();
                        this.totalCount = apiResponse.productsWithMetaData.totalCount;
                        this.products = apiResponse.productsWithMetaData.list;
                        this.filters = filters;
                        this.collectionIds = collectionIds;
                        this.sorting = sorting;
                        this.sendTrackEvent(0);
                        return [2 /*return*/, this.products];
                }
            });
        });
    };
    ProductsService.prototype.getInitialData = function (externalId, compid) {
        var _this = this;
        return this.dataApi.getInitialData(externalId, compid, this.productsPerPage).then(function (_a) {
            var data = _a.data;
            _this.initState(data);
            return data;
        });
    };
    ProductsService.prototype.initState = function (data) {
        this.products = data.catalog.category.productsWithMetaData.list;
        this.totalCount = data.catalog.category.productsWithMetaData.totalCount;
        this.collectionIds = { mainCategory: data.catalog.category.id };
        this.sendTrackEvent(0);
    };
    ProductsService.prototype.sendTrackEvent = function (fromIndex) {
        var _this = this;
        if (this.siteStore.isSSR()) {
            return;
        }
        var items = this.products.slice(fromIndex).map(function (p, i) { return ({
            id: p.id,
            name: p.name,
            list: _this.consumerName,
            category: TRACK_EVENT_COLLECTION,
            position: i + fromIndex,
            price: p.comparePrice || p.price,
            currency: _this.siteStore.currency,
        }); });
        this.siteStore.windowApis.trackEvent('AddProductImpression', {
            appDefId: APP_DEFINITION_ID,
            contents: items,
            origin: 'Stores',
        });
    };
    ProductsService.prototype.hasMoreProductsToLoad = function () {
        return this.products.length < this.totalCount;
    };
    ProductsService.prototype.setProductsPerPage = function (productsPerPage) {
        this.productsPerPage = productsPerPage;
    };
    ProductsService.prototype.removeNotUIVisibleProducts = function (visibleProducts) {
        if (visibleProducts !== this.products.length) {
            this.products = this.products.slice(0, visibleProducts);
        }
    };
    ProductsService.prototype.getProduct = function (id) {
        return this.products.filter(function (p) { return p.id === id; })[0];
    };
    ProductsService.prototype.getCategoryProducts = function (_a) {
        var compId = _a.compId, limit = _a.limit, offset = _a.offset;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _b, data, retrievedProducts;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.dataApi.getCategoryProducts({
                            compId: compId,
                            limit: limit,
                            offset: offset,
                        })];
                    case 1:
                        data = (_c.sent()).data;
                        retrievedProducts = data.catalog.category.productsWithMetaData.list;
                        (_b = this.products).splice.apply(_b, [offset, retrievedProducts.length].concat(retrievedProducts));
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductsService.prototype.loadMoreProducts = function (visibleProducts) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var apiResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.removeNotUIVisibleProducts(visibleProducts);
                        return [4 /*yield*/, this.dataApi.getProducts(visibleProducts, visibleProducts + this.productsPerPage, this.filters, this.collectionIds, this.sorting)];
                    case 1:
                        apiResponse = _a.sent();
                        if (apiResponse.productsWithMetaData.list.length === 0) {
                            return [2 /*return*/, null];
                        }
                        this.products = this.products.concat(apiResponse.productsWithMetaData.list);
                        this.sendTrackEvent(visibleProducts);
                        return [2 /*return*/, this.products];
                }
            });
        });
    };
    ProductsService.prototype.sortProducts = function (sorting) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getProducts(this.filters, this.collectionIds, sorting)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.products];
                }
            });
        });
    };
    ProductsService.prototype.filterProducts = function (filters, collectionIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getProducts(filters, collectionIds, this.sorting)];
                    case 1:
                        _a.products = _b.sent();
                        return [2 /*return*/, this.products];
                }
            });
        });
    };
    ProductsService.prototype.getMainCollectionId = function () {
        return this.collectionIds.mainCategory;
    };
    ProductsService.prototype.storeNavigation = function (pageId) {
        var paginationMap = this.products.map(function (p) { return p.urlPart; });
        var history = {
            pageId: pageId,
            paginationMap: paginationMap,
        };
        this.siteStore.storage.local.setItem(STORAGE_PAGINATION_KEY, JSON.stringify(history));
    };
    ProductsService.prototype.quickViewProduct = function (productId, urlPart, compId, externalId) {
        return this.productActions.quickViewProduct(productId, 'gallery', urlPart, compId, externalId);
    };
    return ProductsService;
}());
export { ProductsService };
//# sourceMappingURL=ProductsService.js.map